module.exports = __webpack_public_path__ + "static/einscanpro-46adf5d22b01dabae5ab8b160043c6d7.jpg";